import React, { useEffect, useState } from "react";
import Barcode from "react-barcode";
import axios from "axios";
import { Button } from "@mui/material";
import { useParams } from "react-router-dom";
import "./barcodeprint.css";

const ManualStkBarcodeView = () => {
  const { barcode, itemId } = useParams();
    console.log(barcode, itemId); // ✅ must show values

  const [rows, setRows] = useState([]);
  const baseUrl = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    if (barcode && itemId) {
      fetchBarcodes();
    }
  }, [barcode, itemId]);

  const fetchBarcodes = async () => {
    try {
      const res = await axios.get(baseUrl, {
        params: {
          apicall: "getItemBarcodeList",
          barcode,
          itemId
        }
      });
      console.log("res.data=>",res.data?.data);
      setRows(res.data?.data || []);
    } catch (err) {
      console.error("Barcode fetch error", err);
      setRows([]);
    }
  };

  const handlePrint = () => {
    document.getElementById("printBtn").style.display = "none";
    window.print();
  };

  return (
    <>
      <Button
        id="printBtn"
        variant="contained"
        size="small"
        onClick={handlePrint}
        sx={{ mb: 2 }}
      >
        Print
      </Button>

      {rows.map((item, idx) => (
        <div className="barcode-label" key={idx}>
          <h3 className="company">{item.itemNm}</h3>

          <div className="details">{item.mclothNm}</div>

          <div className="row">
            <div>Rack: {item.rack}</div>
          </div>
          <div className="row">
        <div>Loc: {item.locNm}</div>
          </div>
            

          <Barcode
            value={item.barcode}
            format="CODE128"
            width={1.5}
            height={55}
            fontSize={12}
            margin={0}
            background="#fff"
            lineColor="#000"
            displayValue
          />

          <div className="row big">
            <strong>Qty:</strong> {item.qty}
          </div>
        </div>
      ))}
    </>
  );
};

export default ManualStkBarcodeView;
